import axios from "axios";
import { BrightyService } from "./service.ts";
import { BrightyFilters, FindBrightyChatByIdDTO, getAllTitlesResponseDTO, UserMessage } from "./dto.ts";
import { keycloak } from "../../../../lib/keycloak/index.ts";
import { BrightyMessagesResponseDTO } from "./dto.ts";

export class BrightyServiceImpl implements BrightyService {
    
    deleteChat(thread_id: string): Promise<void> {
       const url = '/api/agent/title?thread_id=' + thread_id

       return axios({
        url: url,
        method: "PUT",
        headers: {
            Authorization: 'Bearer ' + keycloak.token,
            Accept: '*/*',
            ContentType: 'application/json',
            "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
            "Access-Control-Allow-Origin": "http://localhost:3000",
            "Access-Control-Allow-Methods": "GET",
        }
    }).then((response) => response.data)
    }

    public getTitle(thread_id?: string): Promise<string | getAllTitlesResponseDTO> {
        const url = '/api/agent/title' + (thread_id?  ('?thread_id=' +  thread_id) : '')

        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findBrightyChatById(id: string): Promise<FindBrightyChatByIdDTO> {
        const url = '/api/agent/?thread_id=' + id

        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public sendMessage(message: UserMessage): Promise<void> {
        const url = '/api/agent'
        return axios({
            url: url,
            method: "POST",
            data: message,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findBrightyChats(filters: BrightyFilters): Promise<BrightyMessagesResponseDTO> {
        const url = '/api/agent/'

        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

} 